const PATHS = {
  CONFIG: {
    DEFAULT: '/auth',
    AFTER_LOGIN: '/dashboard',
    AFTER_LOGOUT: '/auth',
    AFTER_SIGNUP: '/dashboard'
  },
  UNAUTHENTICATED: {
    LOGIN: '/auth',
    LOGIN_WITH_EMAIL: '/auth/login-with-email',
    SIGNUP: '/auth/signup',
    SIGNUP_WITH_EMAIL: '/auth/sign-up-with-email',
    FORGOT_PASSWORD: '/auth/forgot-password',
    CONFIRM_EMAIL: '/auth/confirm-email'
  },
  SERVICE: {
    ACCESS_DENIED: '/service/access-denied',
    GDPR: '/service/gdpr',
    NOT_FOUND: '/service/404',
    TERMS_AND_CONDITIONS: '/service/terms-and-conditions'
  },
  AUTHENTICATED: {
    SETTINGS_ALL: '/settings',
    DASHBOARD: '/dashboard',
    PRODUCTS_ALL: '/products',
    PRODUCT_CHANGE_LOGS: '/product-change-logs',
    PRODUCT_SHOW: '/products/:productId',
    PRODUCT_EDIT: '/products/:productId/edit',
    PRODUCT_CREATE: '/products/create',
    VIRTUAL_PRODUCT_CREATE: '/virtual-products/create/:gtin',
    VIRTUAL_PRODUCT_SHOW: '/virtual-products/:virtualProductId',
    VIRTUAL_PRODUCT_EDIT: '/virtual-products/:virtualProductId/edit',
    INGREDIENTS_TREES_ALL: '/ingredientsTrees',
    INGREDIENTS_ALL: '/ingredients',
    INGREDIENT_SHOW: '/ingredients/:ingredientId',
    INGREDIENT_EDIT: '/ingredients/:ingredientId/edit',
    INGREDIENT_CREATE: '/ingredients/create',
    SEARCH_ITEMS_ALL: '/search-items',
    SEARCH_ITEM_SHOW: '/search-items/:searchItemId',
    SEARCH_ITEM_EDIT: '/search-items/:searchItemId/edit',
    SEARCH_ITEM_CREATE: '/search-item/create',
    USER_SHOW: '/users/:userId',
    TRANSLATIONS: '/translations',
    USERS_ALL: '/users',
    USER_EDIT: '/users/:userId/edit',
    CUSTOM_PRODUCTS_ALL: '/custom-products',
    CUSTOM_PRODUCT_SHOW: '/custom-products/:customProductId',
    CUSTOM_PRODUCT_CREATE: '/custom-product/create',
    IMPACT_MEASUREMENTS_ALL: '/impact-measurements',
    IMPACT_MEASUREMENT_SHOW: '/impact-measurements/:impactMeasurementId',
    IMPACT_MEASUREMENT_EDIT: '/impact-measurements/:impactMeasurementId/edit',
    IMPACT_MEASUREMENT_CREATE: '/impact-measurement/create',
    QUESTIONS_ALL: '/questions',
    QUESTION_SHOW: '/questions/:questionId',
    QUESTION_CREATE: '/questions/create',
    QUESTION_EDIT: '/questions/:questionId/edit',
    IMPACT_MEASUREMENT_QUESTIONS_ALL:
      '/impact-measurements/:impactMeasurementId/questions',
    IMPACT_MEASUREMENT_QUESTION_EDIT:
      '/impact-measurements/:impactMeasurementId/questions/:questionId/edit',
    IMPACT_MEASUREMENT_QUESTION_SHOW:
      '/impact-measurements/:impactMeasurementId/questions/:questionId',
    IMPACT_MEASUREMENT_QUESTION_CREATE:
      '/impact-measurements/:impactMeasurementId/questions/create',
    ANSWERS_ALL: '/answers',
    ANSWER_SHOW: '/answers/:answerId',
    LANGUAGES_ALL: '/settings/languages',
    SETTINGS_TRANSLATIONS: '/settings/translations',
    SETTINGS_APP_TRANSLATIONS: '/settings/app-translations',
    SETTINGS_DASHBOARD_TRANSLATIONS: '/settings/dashboard-translations',
    VERSIONS_AVAILABILITIES_ALL: '/settings/control-version',
    SETTINGS_FOOD_DIETARY: '/settings/food-dietary',
    SETTINGS_AI_PROMPT: '/settings/ai-prompt',
    LANGUAGE_CREATE: '/settings/languages/create',
    NOTIFICATION_SHOW: '/notifications/:notificationId',
    NOTIFICATIONS_ALL: '/notifications',
    NOTIFICATION_EDIT: '/notifications/:notificationId/edit',
    NOTIFICATION_CREATE: '/notification/create',
    RECEIVER_SHOW: '/receivers/:receiverId',
    RECEIVER_EDIT: '/receivers/:receiverId/edit',
    RECEIVERS_ALL: '/receivers',
    RECEIVER_CREATE: '/receiver/create',
    VERSION_SHOW: '/versions/:versionId',
    VERSION_EDIT: '/versions/:versionId/edit',
    VERSIONS_ALL: '/versions',
    VERSION_CREATE: '/version/create',
    STATISTICS: '/statistics',
    USER_SUBMITTED_PRODUCTS_ALL: '/user-submitted-products',
    USER_SUBMITTED_PRODUCT_SHOW: '/user-submitted-products/:submissionId'
  }
}

export default PATHS
